import { Pronouns } from '@goldcast/player-config/src/types/speaker-types';

export const PronounOptions: { value: Pronouns | ''; label: string }[] = [
  { value: '', label: '-' },
  { value: Pronouns.SHE, label: 'She/her/hers' },
  { value: Pronouns.HE, label: 'He/him/his' },
  { value: Pronouns.THEY, label: 'They/them/theirs' }
];
